/**
 * mwApp.vods module <br>
 * Work with VODs: show/add/edit/remove
 *
 * @namespace mwApp/vods
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/vods
 * @see mwApp/vods
 *
 * @ngdoc config
 * @name mwApp/vods.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /vods
     */
    .state('app.vods', {
      abstract: true,
      url: '/vods',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/vods.controller:VodsCtrl}
     * @name /vods
     * @memberof mwApp/vods.config:ConfigRoutes
     */
    .state('app.vods.list', {
      url: '',
      templateUrl: 'components/vods/views/vods.html',
      controller: 'VodsCtrl as vm',
      label: 'Video on Demand',
      access: 'viewVod'
    })

    /**
     * abstract state for /:vodId
     */
    .state('app.vods.vod', {
      abstract: true,
      url: '/:vodId',
      template: '<ui-view/>',
      resolve: {
        extra: /* @ngInject */ function ($transition$, VOD) {
          const { vodId: id } = $transition$.params()
          return VOD.loadExtra(VOD.extraFor({ id: +id || 0 }))
        },
        vod: /* @ngInject */ function ($transition$, VOD) {
          const { vodId: id } = $transition$.params()
          return (+id) ? VOD.load({ id }) : new VOD()
        },
        allNetworksById: /* @ngInject */ function (extra, vod) {
          const networks = [...extra.networks, ...vod.networks]
          return networks.reduce((acc, item) => Object.assign(acc, { [item.id]: item }), {})
        }
      }
    })

    /**
     * controller {@link mwApp/vods.controller:AddVodCtrl}
     * @name /vods/:vodId
     * @memberof mwApp/vods.config:ConfigRoutes
     */
    .state('app.vods.vod.edit', {
      url: '',
      templateUrl: 'components/vods/views/addVod.html',
      controller: 'AddVodCtrl as vm',
      label: '{{::vodId | addOrEdit}} VOD',
      access: ':vodId (+) ! IF createVod ELSE editVod'
    })

  /**
   */
    .state('app.vods.vod.contentSets', {
      url: '/contentSets',
      templateUrl: 'components/common/components/assignContentSets/assignContentSets.html',
      controller: 'AssignContentSetsCtrl as vm',
      label: 'Edit Content Sets',
      resolve: {
        contentItem: /* @ngInject */ function ($transition$, VOD) {
          const { vodId: id } = $transition$.params()
          return (+id) ? VOD.load({ id }) : new VOD()
        },
        allContentSets: /* @ngInject */ function (VOD, vod) {
          return VOD.loadAvailableContentSets(vod)
        }
      }
    })
}
